import React from 'react';
import { Link } from 'react-router-dom';
import { HiOutlineHome } from 'react-icons/hi';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen bg-secondary-50 flex flex-col justify-center items-center px-4">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-primary-600">404</h1>
        <h2 className="text-2xl font-semibold text-secondary-900 mt-4">
          Page not found
        </h2>
        <p className="text-secondary-600 mt-2 max-w-md">
          Sorry, we couldn't find the page you're looking for. It may have been moved or deleted.
        </p>
        
        <Link
          to="/dashboard"
          className="inline-flex items-center mt-6 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
        >
          <HiOutlineHome className="h-5 w-5 mr-2" />
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
};

export default NotFound; 